import React from 'react';
import '../styles/about.css'; // Importando o CSS específico para a seção "Sobre Nós"
import quemSomos from "../assets/images/quem-somos2.png";
import { FaEye, FaBullseye, FaHandshake } from 'react-icons/fa'; // Ícones para Visão, Missão e Valores

const About = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img
              src={quemSomos}
              alt="Imagem da Empresa"
              className="about-img"
            />
          </div>
          <div className="about-text">
            <h2 className="about-title">Sobre Nós</h2>
            <p className="about-description">
              A Ficael é uma empresa brasileira, fundada em 1955 como a primeira distribuidora de cabos elétricos da Pirelli no Brasil.
              A empresa atua em três grandes áreas de negócio: cabos e conectividades, filmes de poliéster e isolantes elétricos, mantém estoque das melhores marcas e produtos, oferece a seus clientes um atendimento personalizado, suporte técnico e logística eficiente.
              Seus produtos são usados nos mercados de rádio e TV, telecomunicações, transporte, óleo e gás, mineração, segurança, construção, engenharia, agricultura, embalagem, gráfica, indústria de cabos, motores e geradores.
            </p>

            {/* Cards de Missão, Visão e Valores */}
            <div className="cards-container">
              <div className="card">
                <FaEye className="card-icon" />
                <h3 className="card-title">Visão</h3>
                <p className="card-description-about">
                  Ser um fornecedor referencial nos mercados em que atuamos.
                </p>
              </div>
              <div className="card">
                <FaBullseye className="card-icon" />
                <h3 className="card-title">Missão</h3>
                <p className="card-description-about">
                  Oferecer ao mercado diversidade de produtos de qualidade, com condições comerciais competitivas e suporte técnico apropriado, para obtermos a satisfação e fidelidade dos nossos clientes.
                </p>
              </div>
              <div className="card">
                <FaHandshake className="card-icon" />
                <h3 className="card-title">Valores</h3>
                <p className="card-description-about">
                  Integridade, Responsabilidade Social e Ambiental, Trabalho em Equipe e Inovação.
                 </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
